import Proxy from '../Proxy';

class StatsOrdersProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param orderType
   * @param {Object} parameters The query parameters.
   */
  constructor(orderType, parameters = {}) {
    if (orderType) {
      super(`stats/${orderType}`, parameters);
    } else {
      super('stats', parameters);
    }
  }

  latestDaysCreated() {
    return this.submit('get', `${this.endpoint}/latest-days-created`);
  }

  latestDaysCreatedSubscriptionOrders() {
    return this.setParameter('type', 'subscription')
      .submit('get', `${this.endpoint}/latest-days-created`);
  }

  latestDaysCreatedBase() {
    return this.setParameter('type', 'base')
      .submit('get', `${this.endpoint}/latest-days-created`);
  }

  latestDaysDone() {
    return this.submit('get', `${this.endpoint}/latest-days-done`);
  }

  comingDays() {
    return this.submit('get', `${this.endpoint}/coming-days`);
  }

  nextDay() {
    return this.submit('get', `${this.endpoint}/next-day`);
  }

  separatedOrdered() {
    return this.submit('get', `${this.endpoint}/days-with-separated-ordered`);
  }

  bySources() {
    return this.submit('get', `${this.endpoint}/by-sources`);
  }

  byPromocode() {
    return this.submit('get', `${this.endpoint}/by-promocode`);
  }
}

export default StatsOrdersProxy;
